export default __webpack_public_path__ + "07bb52c6b9554006ce911d1448bec760.svg";